export default "__VITE_ASSET__vt7jDaaq__"